import ReferralTrigger from './ReferralTrigger';
export default ReferralTrigger;